"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const MemoizedWrapper = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    children
  } = _ref;
  return children;
});
var _default = exports.default = MemoizedWrapper;